import Paper from "@mui/material/Paper";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

import SoftTypography from "components/SoftTypography";
const ConnectionOutput = ({ data }) => {
  return (
    <Paper className="custom-light-theme" sx={{ p: 2, display: "flex", alignItems: "center", gap: 1, backgroundColor: "#ededed" }}>
      {data?.statusCode === 500 && <HighlightOffIcon color="error" />}
      {data?.statusCode === 200 && <CheckCircleOutlineIcon color="success" />}
      <SoftTypography variant="caption" color={data?.statusCode === 500 ? "error" : "success"}>
        {data?.statusCode === 500 && "Connection failed. "}{data?.body && data?.body?.message}
      </SoftTypography>
    </Paper>
  );
};

export default ConnectionOutput;
